export default "__VITE_ASSET__CwyY9eKA__"